import resume from '../assets/pdf/resume.pdf'
import  Subham  from '../jpg/subham.jpg'
export const headerData = {
    name: 'Subham Gupta',
    title: "Web Developer",
    desciption:"Web developer with a specialization in front-end development. Adaptable to new technology to enhance my skills and capabilities.",
    image: Subham,
    resumePdf: resume
}
